/**
 * DASHBOARD-PARTICIPATION-OVERVIEW-SKELETON.WIDGET
 * Skeleton adapté à dashboard-participation-overview.widget.tsx : 3 stats empilées
 * (header + valeur), même largeur (140px) pour éviter tout saut de layout.
 */
import Skeleton from "@/components/skeleton"

export default function DashboardParticipationOverviewSkeletonWidget() {
  return (
    <div className="flex flex-dcol" style={{ width: 140, gap: 24 }}>
      {[0, 1, 2].map((i) => (
        <div key={i}>
          <Skeleton width={100} height={11} style={{ marginBottom: 6 }} />
          <Skeleton width={70} height={11} style={{ marginBottom: 12 }} />
          <div className="flex items-center" style={{ gap: 8 }}>
            <Skeleton width={18} height={18} isCircle />
            <Skeleton width={32} height={20} />
          </div>
        </div>
      ))}
    </div>
  )
}
